import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StageComponent, CoreShapeComponent } from 'ng2-konva';

import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../../shared/pless-shared.module';

import { PageComponent } from './page.component';
import { SectionComponent } from './section.component';
import { KomaComponent } from './koma.component';
import { GoodsComponent } from './goods.component';


/**
 * マーク管理画面 モジュール設定クラス
 *
 * @export PageComponent
 * @class PageComponent
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    StageComponent,
    CoreShapeComponent,
  ],
  declarations: [
    PageComponent,
    SectionComponent,
    KomaComponent,
    GoodsComponent,
  ],
  providers: [
  ],
  exports: [
    PageComponent,
  ]
})
export class PageModule {
}
